import { render, staticRenderFns } from "./policy-remark.vue?vue&type=template&id=d53a422e&scoped=true&"
import script from "./policy-remark.vue?vue&type=script&lang=js&"
export * from "./policy-remark.vue?vue&type=script&lang=js&"
import style0 from "./policy-remark.vue?vue&type=style&index=0&id=d53a422e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53a422e",
  null
  
)

export default component.exports